<template>
  <div class="admin-dashboard-root min-h-screen bg-slate-50 flex">
<main class="flex-1 p-6 lg:p-8">
      <div class="dashboard-container">
      <header class="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
        <div>
          <h1 class="text-2xl font-bold text-slate-800">Panel de Control Admin</h1>
          <p class="text-slate-500">Estado global de la infraestructura multiempresa.</p>
        </div>
        <div class="flex items-center gap-3">
          <select class="bg-white border border-slate-200 rounded-lg px-4 py-2 text-sm shadow-sm outline-none">
            <option>Últimos 30 días</option>
            <option>Últimos 7 días</option>
            <option>Este año</option>
          </select>
          <button class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition shadow-md shadow-blue-200">
            Nueva Empresa +
          </button>
        </div>
      </header>

      <!-- ── KPIs principales ────────────────────────────────────────────── -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <p class="text-sm text-slate-500 font-medium">Empresas Activas</p>
          <div class="flex items-end justify-between mt-2">
            <h2 class="text-3xl font-bold text-slate-800">124</h2>
            <span class="text-green-500 text-xs font-bold bg-green-50 px-2 py-1 rounded">+12%</span>
          </div>
        </div>
        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <p class="text-sm text-slate-500 font-medium">Ingresos Mensuales (MRR)</p>
          <div class="flex items-end justify-between mt-2">
            <h2 class="text-3xl font-bold text-slate-800">$12,450</h2>
            <span class="text-blue-500 text-xs font-bold bg-blue-50 px-2 py-1 rounded">Estable</span>
          </div>
        </div>
        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <p class="text-sm text-slate-500 font-medium">Uso de Módulos (Promedio)</p>
          <div class="flex items-end justify-between mt-2">
            <h2 class="text-3xl font-bold text-slate-800">84%</h2>
            <span class="text-green-500 text-xs font-bold bg-green-50 px-2 py-1 rounded">↑ Alta</span>
          </div>
        </div>
        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <p class="text-sm text-slate-500 font-medium">Tasa de Churn (Bajas)</p>
          <div class="flex items-end justify-between mt-2">
            <h2 class="text-3xl font-bold text-slate-800">1.2%</h2>
            <span class="text-red-500 text-xs font-bold bg-red-50 px-2 py-1 rounded">↓ -0.5%</span>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
        <div class="lg:col-span-2 bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <div class="flex items-center justify-between mb-6">
            <h3 class="font-bold text-slate-800">Crecimiento de Tenants</h3>
            <span class="text-xs text-slate-400">Enero - Diciembre 2026</span>
          </div>
          <div class="h-64 bg-slate-50 rounded-lg flex items-end justify-around p-4 gap-2">
            <div class="w-full bg-blue-200 rounded-t h-[30%]"></div>
            <div class="w-full bg-blue-300 rounded-t h-[45%]"></div>
            <div class="w-full bg-blue-400 rounded-t h-[60%]"></div>
            <div class="w-full bg-blue-500 rounded-t h-[85%]"></div>
            <div class="w-full bg-blue-600 rounded-t h-[100%]"></div>
          </div>
        </div>

        <div class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <h3 class="font-bold text-slate-800 mb-6">Planes Activos</h3>
          <div class="space-y-4">
            <div v-for="plan in plans" :key="plan.name">
              <div class="flex justify-between text-sm mb-1">
                <span class="text-slate-600 font-medium">{{ plan.name }}</span>
                <span class="text-slate-400">{{ plan.count }} empresas</span>
              </div>
              <div class="w-full bg-slate-100 rounded-full h-2">
                <div :class="['h-2 rounded-full', plan.color]" :style="{ width: plan.percent + '%' }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
          <div class="p-4 border-b border-slate-100 bg-slate-50/50">
            <h3 class="font-bold text-slate-800 text-sm">Últimas Empresas Registradas</h3>
          </div>
          <table class="w-full text-left text-sm">
            <tbody class="divide-y divide-slate-100">
              <tr v-for="i in 4" :key="i" class="hover:bg-slate-50 transition">
                <td class="p-4 flex items-center gap-3">
                  <div class="w-8 h-8 rounded bg-slate-200"></div>
                  <span class="font-medium text-slate-700">Empresa Alpha {{ i }}</span>
                </td>
                <td class="p-4 text-slate-500 text-xs font-mono">alpha{{ i }}.saas.io</td>
                <td class="p-4 text-right">
                  <span class="px-2 py-0.5 rounded-full text-[10px] font-bold bg-blue-100 text-blue-700">PLAN PRO</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
          <h3 class="font-bold text-slate-800 mb-4 text-sm">Estado Global de Módulos</h3>
          <div class="grid grid-cols-2 gap-4">
            <div v-for="module in modules" :key="module.name" class="p-3 border border-slate-100 rounded-lg flex items-center justify-between">
              <div>
                <p class="text-xs font-bold text-slate-700">{{ module.name }}</p>
                <p class="text-[10px] text-slate-400">{{ module.activeTenants }} tenants</p>
              </div>
              <div :class="['w-2 h-2 rounded-full', module.status === 'ok' ? 'bg-green-500' : 'bg-red-500 animate-pulse']"></div>
            </div>
          </div>
        </div>
      </div>
          </div>

      <!-- ── Infraestructura Hostinger ──────────────────────────────────── -->
      <section class="mt-8">
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center gap-3">
            <div>
              <h2 class="text-lg font-bold text-slate-800">Infraestructura Hostinger</h2>
              <p class="text-xs text-slate-500 mt-0.5">Estado en tiempo real del hosting y subdominios activos.</p>
            </div>
            <!-- Badge compacto cuando la API de Hostinger tiene fallo de infraestructura (HTTP 530) -->
            <span v-if="metricas.api_no_accesible"
              class="inline-flex items-center gap-1 bg-amber-100 text-amber-700 text-[10px] font-bold px-2 py-1 rounded-full whitespace-nowrap">
              <svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              API Hostinger temporalmente no disponible
            </span>
          </div>
          <button
            @click="recargarHostinger"
            :disabled="cargandoHostinger"
            class="flex items-center gap-2 bg-white border border-slate-200 hover:border-blue-400 text-slate-600 hover:text-blue-600 px-4 py-2 rounded-lg text-xs font-semibold transition shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg
              :class="['w-3.5 h-3.5 transition-transform', cargandoHostinger ? 'animate-spin' : '']"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            >
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
            </svg>
            Actualizar
          </button>
        </div>

        <!-- Error real -->
        <div v-if="errorHostinger && !metricas.api_no_accesible" class="bg-red-50 border border-red-200 rounded-xl p-4 text-sm text-red-700 flex items-start gap-3 mb-4">
          <svg class="w-5 h-5 flex-shrink-0 mt-0.5 text-red-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          <div>
            <p class="font-semibold">No se pudieron cargar las métricas de Hostinger</p>
            <p class="text-red-600 mt-0.5">{{ errorHostinger }}</p>
          </div>
        </div>

        <!-- KPIs y tablas: solo visibles cuando hay datos reales -->
        <template v-if="!metricas.api_no_accesible">

        <!-- KPIs de infraestructura -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          <!-- Websites -->
          <div class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm">
            <div class="flex items-center gap-3 mb-3">
              <div class="w-9 h-9 rounded-lg bg-blue-50 flex items-center justify-center">
                <svg class="w-5 h-5 text-blue-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="2" y1="12" x2="22" y2="12"/>
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                </svg>
              </div>
              <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide">Websites</p>
            </div>
            <div v-if="cargandoHostinger" class="h-7 bg-slate-100 rounded animate-pulse"></div>
            <p v-else class="text-3xl font-bold text-slate-800">{{ metricas.total_websites ?? '—' }}</p>
            <p class="text-xs text-slate-400 mt-1">Alojados en Hostinger</p>
          </div>

          <!-- Subdominios activos -->
          <div class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm">
            <div class="flex items-center gap-3 mb-3">
              <div class="w-9 h-9 rounded-lg bg-indigo-50 flex items-center justify-center">
                <svg class="w-5 h-5 text-indigo-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                </svg>
              </div>
              <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide">Subdominios</p>
            </div>
            <div v-if="cargandoHostinger" class="h-7 bg-slate-100 rounded animate-pulse"></div>
            <p v-else class="text-3xl font-bold text-slate-800">{{ metricas.total_subdominios ?? '—' }}</p>
            <p class="text-xs text-slate-400 mt-1">DNS activos en {{ metricas.dominio_principal ?? 'sicecom.com' }}</p>
          </div>

          <!-- Dominio principal -->
          <div class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm">
            <div class="flex items-center gap-3 mb-3">
              <div class="w-9 h-9 rounded-lg bg-emerald-50 flex items-center justify-center">
                <svg class="w-5 h-5 text-emerald-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide">Dominio</p>
            </div>
            <div v-if="cargandoHostinger" class="h-7 bg-slate-100 rounded animate-pulse"></div>
            <p v-else class="text-sm font-bold text-slate-800 break-all">{{ metricas.dominio_principal ?? '—' }}</p>
            <p class="text-xs text-slate-400 mt-1">Dominio principal del sistema</p>
          </div>

          <!-- Última actualización -->
          <div class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm">
            <div class="flex items-center gap-3 mb-3">
              <div class="w-9 h-9 rounded-lg bg-slate-100 flex items-center justify-center">
                <svg class="w-5 h-5 text-slate-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
              </div>
              <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide">Actualizado</p>
            </div>
            <div v-if="cargandoHostinger" class="h-7 bg-slate-100 rounded animate-pulse"></div>
            <p v-else class="text-xs font-bold text-slate-700 break-all">{{ metricas.actualizado_en ?? '—' }}</p>
            <p class="text-xs text-slate-400 mt-1">Última consulta a Hostinger</p>
          </div>
        </div>

        <!-- Tabla de subdominios -->
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <!-- Listado de websites -->
          <div class="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden">
            <div class="p-4 border-b border-slate-100">
              <h3 class="text-sm font-bold text-slate-700">Websites en Hosting</h3>
            </div>
            <div v-if="cargandoHostinger" class="p-4 space-y-3">
              <div v-for="n in 3" :key="n" class="h-8 bg-slate-100 rounded animate-pulse"></div>
            </div>
            <div v-else-if="!metricas.websites || metricas.websites.length === 0"
              class="p-6 text-center text-slate-400 text-sm">
              No se encontraron websites
            </div>
            <table v-else class="w-full text-sm">
              <thead class="bg-slate-50">
                <tr>
                  <th class="text-left p-3 text-xs font-semibold text-slate-500">Dominio</th>
                  <th class="text-left p-3 text-xs font-semibold text-slate-500">Tipo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="web in metricas.websites" :key="web.dominio"
                  class="border-t border-slate-50 hover:bg-slate-50 transition">
                  <td class="p-3 text-slate-700 text-xs font-mono">{{ web.dominio }}</td>
                  <td class="p-3">
                    <span :class="['px-2 py-0.5 rounded-full text-[10px] font-bold', web.dominio_padre ? 'bg-indigo-100 text-indigo-700' : 'bg-emerald-100 text-emerald-700']">
                      {{ web.dominio_padre ? 'subdominio' : 'principal' }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Listado de subdominios DNS -->
          <div class="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden">
            <div class="p-4 border-b border-slate-100 flex items-center justify-between">
              <h3 class="text-sm font-bold text-slate-700">Subdominios DNS Activos</h3>
              <span v-if="metricas.total_subdominios"
                class="bg-indigo-100 text-indigo-700 text-[10px] font-bold px-2 py-0.5 rounded-full">
                {{ metricas.total_subdominios }} total
              </span>
            </div>
            <div v-if="cargandoHostinger" class="p-4 space-y-3">
              <div v-for="n in 5" :key="n" class="h-8 bg-slate-100 rounded animate-pulse"></div>
            </div>
            <div v-else-if="!metricas.subdominios || metricas.subdominios.length === 0"
              class="p-6 text-center text-slate-400 text-sm">
              No se encontraron subdominios en DNS
            </div>
            <div v-else class="overflow-y-auto max-h-72">
              <table class="w-full text-sm">
                <thead class="bg-slate-50 sticky top-0">
                  <tr>
                    <th class="text-left p-3 text-xs font-semibold text-slate-500">Subdominio</th>
                    <th class="text-left p-3 text-xs font-semibold text-slate-500">Tipo</th>
                    <th class="text-center p-3 text-xs font-semibold text-slate-500">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="sub in metricas.subdominios" :key="sub.fqdn"
                    class="border-t border-slate-50 hover:bg-slate-50 transition">
                    <td class="p-3 text-slate-700 text-xs font-mono">{{ sub.nombre }}</td>
                    <td class="p-3">
                      <span class="px-2 py-0.5 rounded text-[10px] font-bold bg-slate-100 text-slate-600">{{ sub.tipo }}</span>
                    </td>
                    <td class="p-3 text-center">
                      <span :class="['w-2 h-2 rounded-full inline-block', sub.activo ? 'bg-emerald-500' : 'bg-red-400']"></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        </template><!-- fin v-if !modo_desarrollo -->
      </section>

    </main>
  </div>
</template>

<script>
import hostingerService from '@/services/hostingerService.js'

export default {
  name: 'AdminDashboard',

  data() {
    return {
      plans: [
        { name: 'Enterprise',   count: 12, percent: 30, color: 'bg-indigo-600' },
        { name: 'Business Pro', count: 45, percent: 60, color: 'bg-blue-500' },
        { name: 'Starter',      count: 67, percent: 85, color: 'bg-emerald-400' }
      ],
      modules: [
        { name: 'Facturación Electrónica', activeTenants: 120, status: 'ok' },
        { name: 'Gestión de Inventarios',  activeTenants: 98,  status: 'ok' },
        { name: 'API Externa',             activeTenants: 45,  status: 'error' },
        { name: 'Reportes BI',             activeTenants: 110, status: 'ok' }
      ],

      // ── Hostinger ──────────────────────────────────────────────────────────
      metricas:          {},
      cargandoHostinger: false,
      errorHostinger:    null,
    }
  },

  mounted() {
    this.recargarHostinger()
  },

  methods: {
    async recargarHostinger() {
      this.cargandoHostinger = true
      this.errorHostinger    = null
      try {
        this.metricas = await hostingerService.obtenerMetricas()
        if (this.metricas.errores_api && this.metricas.errores_api.length > 0) {
          this.errorHostinger = this.metricas.errores_api.join(' | ')
        }
      } catch (err) {
        this.errorHostinger = err?.response?.data?.error || err?.message || 'Error al conectar con el servidor'
      } finally {
        this.cargandoHostinger = false
      }
    }
  }
}
</script>

<style scoped>
* { box-sizing: border-box; }

.min-h-screen { min-height: 100vh; }
.flex { display: flex; }
.flex-col { flex-direction: column; }
.flex-1 { flex: 1 1 0%; }
.hidden { display: none; }

.grid { display: grid; }
.grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }
.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }

.w-64 { width: 16rem; }
.w-8 { width: 2rem; }
.w-2 { width: 0.5rem; }
.w-full { width: 100%; }
.h-8 { height: 2rem; }
.h-2 { height: 0.5rem; }
.h-64 { height: 16rem; }

.h-\[30\%\] { height: 30%; }
.h-\[45\%\] { height: 45%; }
.h-\[60\%\] { height: 60%; }
.h-\[85\%\] { height: 85%; }
.h-\[100\%\] { height: 100%; }

.p-3 { padding: 0.75rem; }
.p-4 { padding: 1rem; }
.p-6 { padding: 1.5rem; }
.p-8 { padding: 2rem; }
.px-2 { padding-left: 0.5rem; padding-right: 0.5rem; }
.px-3 { padding-left: 0.75rem; padding-right: 0.75rem; }
.px-4 { padding-left: 1rem; padding-right: 1rem; }
.py-0\.5 { padding-top: 0.125rem; padding-bottom: 0.125rem; }
.py-1 { padding-top: 0.25rem; padding-bottom: 0.25rem; }
.py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; }
.py-4 { padding-top: 1rem; padding-bottom: 1rem; }

.mb-1 { margin-bottom: 0.25rem; }
.mb-4 { margin-bottom: 1rem; }
.mb-6 { margin-bottom: 1.5rem; }
.mb-8 { margin-bottom: 2rem; }
.mt-2 { margin-top: 0.5rem; }
.gap-2 { gap: 0.5rem; }
.gap-3 { gap: 0.75rem; }
.gap-4 { gap: 1rem; }
.gap-6 { gap: 1.5rem; }

.space-y-1 > * + * { margin-top: 0.25rem; }
.space-y-4 > * + * { margin-top: 1rem; }

.items-center { align-items: center; }
.items-end { align-items: flex-end; }
.justify-between { justify-content: space-between; }
.justify-around { justify-content: space-around; }

.overflow-hidden { overflow: hidden; }
.text-left { text-align: left; }
.text-right { text-align: right; }
.uppercase { text-transform: uppercase; }

.text-\[10px\] { font-size: 10px; line-height: 1.2; }
.text-xs { font-size: 0.75rem; line-height: 1rem; }
.text-sm { font-size: 0.875rem; line-height: 1.25rem; }
.text-xl { font-size: 1.25rem; line-height: 1.75rem; }
.text-2xl { font-size: 1.5rem; line-height: 2rem; }
.text-3xl { font-size: 1.875rem; line-height: 2.25rem; }

.font-medium { font-weight: 500; }
.font-semibold { font-weight: 600; }
.font-bold { font-weight: 700; }
.font-mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace; }

.rounded { border-radius: 0.25rem; }
.rounded-lg { border-radius: 0.5rem; }
.rounded-xl { border-radius: 0.75rem; }
.rounded-full { border-radius: 9999px; }
.rounded-t { border-top-left-radius: 0.5rem; border-top-right-radius: 0.5rem; }

.border { border: 1px solid #e2e8f0; }
.border-b { border-bottom: 1px solid #e2e8f0; }
.border-slate-100 { border-color: #f1f5f9; }
.border-slate-200 { border-color: #e2e8f0; }

.bg-white { background: #ffffff; }
.bg-slate-900 { background: #0f172a; }
.bg-slate-800 { background: #1e293b; }
.bg-slate-100 { background: #f1f5f9; }
.bg-slate-50 { background: #f8fafc; }
.bg-slate-50\/50 { background: rgba(248, 250, 252, 0.5); }

.bg-blue-50 { background: #eff6ff; }
.bg-blue-100 { background: #dbeafe; }
.bg-blue-200 { background: #bfdbfe; }
.bg-blue-300 { background: #93c5fd; }
.bg-blue-400 { background: #60a5fa; }
.bg-blue-500 { background: #3b82f6; }
.bg-blue-600 { background: #2563eb; }
.bg-indigo-600 { background: #4f46e5; }
.bg-emerald-400 { background: #34d399; }
.bg-green-50 { background: #f0fdf4; }
.bg-green-500 { background: #22c55e; }
.bg-red-50 { background: #fef2f2; }
.bg-red-500 { background: #ef4444; }

.text-white { color: #ffffff; }
.text-slate-300 { color: #cbd5e1; }
.text-slate-400 { color: #94a3b8; }
.text-slate-500 { color: #64748b; }
.text-slate-600 { color: #475569; }
.text-slate-700 { color: #334155; }
.text-slate-800 { color: #1e293b; }
.text-blue-400 { color: #60a5fa; }
.text-blue-500 { color: #3b82f6; }
.text-blue-700 { color: #1d4ed8; }
.text-green-500 { color: #22c55e; }
.text-red-500 { color: #ef4444; }

.shadow-sm { box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06); }
.shadow-md { box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12); }
.shadow-blue-200 { box-shadow: 0 8px 20px rgba(147, 197, 253, 0.45); }

.transition { transition: all 0.2s ease; }
.hover\:bg-slate-800:hover { background: #1e293b; }
.hover\:bg-blue-700:hover { background: #1d4ed8; }
.hover\:bg-slate-50:hover { background: #f8fafc; }

.outline-none { outline: none; }

.divide-y > * + * { border-top: 1px solid #f1f5f9; }

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
}

.animate-pulse { animation: pulse 1.6s ease-in-out infinite; }
.dashboard-container { max-width: 1480px; margin: 0 auto; }

@media (min-width: 768px) {
  .md\:flex-row { flex-direction: row; }
  .md\:items-center { align-items: center; }
  .md\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (min-width: 1024px) {
  .lg\:flex { display: flex; }
  .lg\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .lg\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .lg\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .lg\:col-span-2 { grid-column: span 2 / span 2; }
}

/* Integracion con tema claro/oscuro del sistema */
.bg-slate-50 { background: var(--bg-main); }
.bg-slate-50\/50 { background: var(--secondary-bg-main); }
.bg-white { background: var(--secondary-bg-main); }
.bg-slate-100 { background: var(--secondary-bg-soft); }

.border,
.border-b,
.border-slate-100,
.border-slate-200 {
  border-color: var(--border-main);
}

.text-slate-300,
.text-slate-400 { color: var(--text-muted); }

.text-slate-500,
.text-slate-600,
.text-slate-700 { color: var(--text-secondary); }

.text-slate-800 { color: var(--text-primary); }

select,
input {
  background: var(--secondary-bg-main);
  color: var(--text-primary);
  border-color: var(--border-main);
}

.shadow-sm,
.shadow-md { box-shadow: var(--shadow-sm); }

/* Ajuste completo de utilidades al tema del sistema */
.min-h-screen { background: var(--bg-main) !important; color: var(--text-primary); }

.bg-slate-900 { background: var(--secondary-bg-soft); }
.bg-slate-800 { background: var(--secondary-bg-muted); }

.text-white { color: var(--text-inverse); }
.text-slate-300,
.text-slate-400,
.text-slate-500,
.text-slate-600,
.text-slate-700,
.text-slate-800 { color: var(--text-primary) !important; }

.text-slate-400,
.text-slate-500,
.text-slate-600 { color: var(--text-secondary) !important; }

.divide-y > * + * { border-top-color: var(--border-main) !important; }

.hover\:bg-slate-50:hover { background: var(--secondary-bg-soft) !important; }

.bg-blue-50 { background: var(--accent-info-light); }
.bg-green-50 { background: var(--accent-success-light); }
.bg-red-50 { background: var(--accent-danger-light); }

.bg-blue-100 { background: rgba(14, 165, 233, 0.2); }
.bg-blue-200 { background: rgba(14, 165, 233, 0.35); }
.bg-blue-300 { background: rgba(14, 165, 233, 0.5); }
.bg-blue-400 { background: rgba(14, 165, 233, 0.65); }
.bg-blue-500 { background: var(--primary-main); }
.bg-blue-600 { background: var(--primary-main); }
.bg-indigo-600 { background: var(--primary-hover); }
.bg-emerald-400 { background: var(--accent-success); }
.bg-red-500 { background: var(--accent-danger); }
.bg-green-500 { background: var(--accent-success); }

.text-blue-500,
.text-blue-700 { color: var(--accent-info); }
.text-green-500 { color: var(--accent-success); }
.text-red-500 { color: var(--accent-danger); }

.hover\:bg-blue-700:hover { background: var(--primary-hover) !important; }

/* Forzar tema por contenedor real del dashboard (fallback incluido) */
.admin-dashboard-root {
  --fondo-principal-local: var(--bg-main, #f8fafc);
  --fondo-secundario-local: var(--secondary-bg-main, #ffffff);
  --fondo-suave-local: var(--secondary-bg-soft, #f1f5f9);
  --texto-principal-local: var(--text-primary, #0f172a);
  --texto-secundario-local: var(--text-secondary, #475569);
  --borde-local: var(--border-main, #e2e8f0);
  background: var(--fondo-principal-local) !important;
  color: var(--texto-principal-local) !important;
}

@media (prefers-color-scheme: dark) {
  .admin-dashboard-root {
    --fondo-principal-local: var(--bg-main, #020617);
    --fondo-secundario-local: var(--secondary-bg-main, #111827);
    --fondo-suave-local: var(--secondary-bg-soft, #0f172a);
    --texto-principal-local: var(--text-primary, #f9fafb);
    --texto-secundario-local: var(--text-secondary, #94a3b8);
    --borde-local: var(--border-main, #374151);
  }
}

.admin-dashboard-root .bg-white {
  background: var(--fondo-secundario-local) !important;
  border-color: var(--borde-local) !important;
}

.admin-dashboard-root .bg-slate-50,
.admin-dashboard-root .bg-slate-50\/50,
.admin-dashboard-root .bg-slate-100 {
  background: var(--fondo-suave-local) !important;
}

.admin-dashboard-root .border,
.admin-dashboard-root .border-b,
.admin-dashboard-root .border-slate-100,
.admin-dashboard-root .border-slate-200 {
  border-color: var(--borde-local) !important;
}

.admin-dashboard-root .text-slate-800,
.admin-dashboard-root .text-slate-700,
.admin-dashboard-root .text-slate-600,
.admin-dashboard-root .text-slate-500,
.admin-dashboard-root .text-slate-400 {
  color: var(--texto-secundario-local) !important;
}

.admin-dashboard-root .text-slate-800,
.admin-dashboard-root .font-bold.text-slate-700,
.admin-dashboard-root h1,
.admin-dashboard-root h2,
.admin-dashboard-root h3 {
  color: var(--texto-principal-local) !important;
}
</style>


